import * as React from "react";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InvestmentType } from "../../../../../Wrap/Constants/Enums/InvestmentType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { PropositionInvestmentConfig } from "../../../../../Wrap/Models/Domains/Account/PropositionInvestmentConfig";
import { AdviserContextStoreStatic } from "../../../../Dashboard/Components/Clients/NewBusinessWizard/Stores/Variable";
import { UserStore } from "../../../../Dashboard/Stroes/Variable";
import { InvestmentTypeMap } from "../../Resource/Content";
import { AdviserPortfolios } from "../AdviserPortfolios";
import { ExchangeTraded } from "../ExchangeTraded/ExchangeTraded";
import { Funds } from "../Funds/Funds";
import { HubPortfolios } from "../HubPortfolio/HubPortfolios";
import { OffPlatform } from "../OffPlatform/OffPlatform";
import { Deposits } from "../Deposits/Deposits";
import { ProductOverviewCrystallisationAction } from "../../../../Dashboard/Components/Clients/PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewCrystallisationAction";
import { useEffect, useState } from "react";
import { Lightbox, LightboxType } from "../../../../../react-core/Html/Components/Lightbox";
import { BatchType } from "../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";

interface ISearchTabs {
    hiercharyId: string;
    product: SubAccountType;
    data: any;
    isUnderTransfer: boolean;
    isUnderSwitch?: boolean
    isUnit?: boolean;
    index?: number;
    onTabClick?: (tabType: InvestmentType) => void;
    researchIst?: boolean;
    disabled?: boolean;
    investmentPermission?: PropositionInvestmentConfig[];
    accountServiceProposition: ServiceProposition;
    canBeBought: boolean;
    canBeSold: boolean;
    includeInsuredFund?: boolean;
    companyServiceProposition: ServiceProposition[];
    batchType?: BatchType;
    selectedPathwayText?: string;
}

export const SearchTabs = (props: ISearchTabs) => {
    if (props.companyServiceProposition.includes(ServiceProposition.NonWrapEnabled)) {
        const hubSetting = props.investmentPermission?.find((p) => p.InvestmentTypeId == InvestmentType.HubPortfolios);
        if (hubSetting) {hubSetting.Enable = false;}
        const adviser = props.investmentPermission?.find((p) => p.InvestmentTypeId == InvestmentType.AdviserPortfolios);
        if (adviser) {adviser.Enable = false;}
    }

    const disabledHubPortfolio = props.investmentPermission?.find(
        (p) => p.InvestmentTypeId === InvestmentType.HubPortfolios && p.Enable === false
    );

    const disabledCashDeposits = (props.accountServiceProposition == ServiceProposition.Fundzone) || ((props.investmentPermission != null && props.investmentPermission.length != 0) && !props.investmentPermission?.find(
        (p) => p.InvestmentTypeId === InvestmentType.CashDeposits && (props.accountServiceProposition == null || p.PropositionId === props.accountServiceProposition)
    )?.Enable || (props.product != null && props.product !== SubAccountType.InvestmentAccount));

    let [activeId, setActiveId] = React.useState(
        props.isUnderTransfer || props.selectedPathwayText != null
            ? InvestmentType.Funds
            : props.isUnit
                ? InvestmentType.AdviserPortfolios
                : InvestmentType.HubPortfolios
    );
    const [activeTailoredDrawdownArrangement, setActiveTailoredDrawdownArrangement] = useState(null);
    const [showTailoredDrawdownPopUp, setShowTailoredDrawdownPopUp] = useState(null);

    if ((activeId === InvestmentType.HubPortfolios && disabledHubPortfolio != null) || (activeId === InvestmentType.CashDeposits && disabledCashDeposits)) {
        activeId = props.investmentPermission?.find((p) => p.Enable === true).InvestmentTypeId;
    }

    const disableBtn = () => {
        const buttonLen = document.getElementsByTagName("button").length;
        for (let i = 0; i < buttonLen; i++) {
            const btn = document.getElementsByTagName("button").item(i);
            if (
                !btn.parentElement.className.includes("action-secondary") &&
                !btn.parentElement.className.includes("action-primary") &&
                !btn.parentElement.className.includes("left-side") &&
                !btn.parentElement.className.includes("right-side")
            ) {
                document.getElementsByTagName("button").item(i).disabled = true;
                document.getElementsByTagName("button").item(i).onclick = null;
                document.getElementsByTagName("button").item(i).style.pointerEvents = "none";
            }
        }
    };
    React.useEffect(() => {
        if (props.disabled) {
            disableBtn();
        }
    }, [props.disabled]);
    React.useEffect(() => {
        if (props.isUnit && activeId == InvestmentType.HubPortfolios) {
            setActiveId(InvestmentType.AdviserPortfolios);
        }
    }, [props.isUnit]);
    React.useEffect(() => {
        if (props.selectedPathwayText != null) {
            setActiveId(InvestmentType.Funds);
        }
    }, [props.selectedPathwayText]);
    const ISTtabs = (): any[] => {
        let tabs = [
            {
                id: InvestmentType.HubPortfolios,
                content: (
                    <HubPortfolios
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        tableData={props.data}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
                    />
                ),
            },
            {
                id: InvestmentType.AdviserPortfolios,
                content: (
                    <AdviserPortfolios
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
                    />
                ),
            },
            {
                id: InvestmentType.Funds,
                content: (
                    <Funds
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        tableData={props.data}
                        index={props.index}
                        researchIst={props.researchIst}
                        accountServiceProposition={props.accountServiceProposition}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
                        includeInsuredFund={props.includeInsuredFund}
                        CanBeTransferred={props.isUnderTransfer}
                        selectedPathwayText={props.selectedPathwayText}
                    />
                ),
            },
            {
                id: InvestmentType.ExchangeTraded,
                content: (
                    <ExchangeTraded
                        researchIst={props.researchIst}
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        tableData={props.data}
                        index={props.index}
                        accountServiceProposition={props.accountServiceProposition}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
			CanBeTransferred={props.isUnderTransfer}
                    />
                ),
            },
            {
                id: InvestmentType.OffPlatform,
                content: (
                    <OffPlatform
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        tableData={props.data}
                        index={props.index}
                        accountServiceProposition={props.accountServiceProposition}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
                        CanBeTransferred={props.isUnderTransfer}
                        TailoredDrawdownAllowed={activeTailoredDrawdownArrangement?.length <= 0}
                    />
                ),
            },
            {
                id: InvestmentType.CashDeposits,
                content: (
                    <Deposits
                        researchIst={props.researchIst}
                        hiercharyId={props.hiercharyId}
                        type={props.product}
                        tableData={props.data}
                        index={props.index}
                        accountServiceProposition={props.accountServiceProposition}
                        canBeBought={props.canBeBought}
                        canBeSold={props.canBeSold}
                        batchType={props.batchType}
                    />
                ),
            },
        ];

        if ([SubAccountType.InvestmentAccount, SubAccountType.StocksIsa].includes(props.product))
            {tabs = tabs.filter((ele) => ele.id != InvestmentType.OffPlatform);}

        if (props.isUnit) {return tabs.filter((ele) => ele.id != InvestmentType.HubPortfolios);}
        
        if (disabledCashDeposits)
            {tabs = tabs.filter((ele) => ele.id !== InvestmentType.CashDeposits)}
        if (props.researchIst)
            {return tabs.filter((ele) => ele.id == InvestmentType.Funds || ele.id == InvestmentType.ExchangeTraded || ele.id == InvestmentType.CashDeposits);}

        if (props.isUnderSwitch) {return tabs.filter((ele) => ele.id != InvestmentType.OffPlatform);}

        if (props.isUnderTransfer)
            {return tabs.filter((ele) => ele.id == InvestmentType.Funds || ele.id == InvestmentType.ExchangeTraded || ele.id == InvestmentType.OffPlatform);}

        return tabs;
    };

    const investmentPermission = props.investmentPermission;  

    return (
        <>
            <nav role="tablist" className="tabs is-ist">
                {ISTtabs()
                    .map(({ id }) => (
                    <button
                        role="tab"
                        onClick={() => {
                            if (props.onTabClick) {
                                props.onTabClick(id);
                            }
                            setActiveId(id);
                            if(id===InvestmentType.OffPlatform && props.hiercharyId !=null){
                                ProductOverviewCrystallisationAction.getRegularCrystallisationDetails(props.hiercharyId, (data) => {
                                    setActiveTailoredDrawdownArrangement(data) ;
                                })
                                setShowTailoredDrawdownPopUp(true)
                            }
                        }}
                        className={
                            (activeId === id ? "item active" : "item") +
                            (investmentPermission?.length > 0 &&
                                !investmentPermission?.find((x) => x.InvestmentTypeId == id)?.Enable
                                ? " btn primary"
                                : "")
                        }
                        key={id}
                        aria-expanded={activeId === id ? true : false}
                        disabled={
                            investmentPermission?.length > 0 &&
                            !investmentPermission?.find((x) => x.InvestmentTypeId == id)?.Enable
                        }
                    >
                        {InvestmentTypeMap[id]}
                    </button>
                ))}
            </nav>
            {ISTtabs().map(({ id, content }, index) => {
                return activeId === id ? <React.Fragment key={`${id}-${index}`}>{content} </React.Fragment> : null;
            })}

            {activeTailoredDrawdownArrangement?.length>0 && showTailoredDrawdownPopUp &&(
                    <Lightbox
                        show={showTailoredDrawdownPopUp}
                        title={""}
                        contentAfterTitle={null}
                        onClose={() => setShowTailoredDrawdownPopUp(false)}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <p>{"Please note Tailored Drawdown is being taken from the Aberdeen SIPP. Only compatible off-platform investments will be shown in the search results."}</p>
                        <button
                            className="btn primary"
                            onClick={() => setShowTailoredDrawdownPopUp(false)}
                        >
                            Close
                        </button>
                    </Lightbox>
                )}
        </>
    );
};
